export default "__VITE_ASSET__ede85f6b__"